import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import * as types from '../../../actions/actionTypes';
import {
  BackSpaceKey,
  KeyB,
  KeyN,
  LeftKey,
  RightKey,
} from '../../utility/Icons';
import styles from './styles';

interface Props {
  classes: any;
  dispatch: any;
  handleClose?: Function;
  padTop?: boolean;
  token: string | null;
}
export function KeyboardControls(props: Props) {
  const { classes, handleClose, dispatch, padTop, token } = props;
  const router = useRouter();

  const onFavoritesClick = () => {
    if (token) {
      const win: any = window.open(`/favorites`, '_blank');
      win.focus();
    } else {
      handleClose && handleClose();
      dispatch({
        postAuthPath: router.pathname,
        signupSubtext: `Sign up for Torii to save your favorite properties, plus free access to property data, trends, and the best way to buy a home.`,
        type: types.OpenSignupDialog,
      });
    }
  };

  return (
    <React.Fragment>
      <div style={{ marginTop: padTop ? 35 : 0 }} className="no-mobile">
        <Typography>Keyboard controls:</Typography>
        <Typography className={classes.controlsRow}>
          <div className={classes.controlsBullet} />
          Press
          <RightKey />
          to save a property to{' '}
          <a
            style={{ color: '#463264', cursor: 'pointer' }}
            onClick={onFavoritesClick}
          >
            &nbsp;your favorites
          </a>
        </Typography>
        <Typography className={classes.controlsRow}>
          <div className={classes.controlsBullet} />
          Press
          <LeftKey />
          to discard a property
        </Typography>
        <Typography className={classes.controlsRow}>
          <div className={classes.controlsBullet} />
          Press
          <KeyN />
          to see the next photo on a listing
        </Typography>
        <Typography className={classes.controlsRow}>
          <div className={classes.controlsBullet} />
          Press
          <KeyB />
          to see the previous photo on a listing
        </Typography>
        <Typography className={classes.controlsRow}>
          <div className={classes.controlsBullet} />
          Press
          <BackSpaceKey />
          to go back to the previous property
        </Typography>
      </div>
      <div style={{ marginTop: padTop ? 35 : 0 }} className="mobile-only">
        <Typography>Controls:</Typography>
        {/* uncomment this part once the Swiper is complete */}
        {/* <div className={classes.stepContainer}>
          <Typography>1){" "}Swipe right on a listing card to save a property to your favorites, swipe left to discard</Typography>
          <img src="/static/img/random/swipe_icon.png" height="164" width="300" className={classes.mobileImageStyle} />
        </div> */}
        <div className={classes.stepContainer}>
          <Typography style={{ fontSize: 14 }}>
            Swipe through homes using the three navigation buttons at the bottom
            of your screen. All of your favorites will be saved{' '}
            <a
              style={{ color: '#463264', cursor: 'pointer' }}
              onClick={onFavoritesClick}
            >
              &nbsp;here
            </a>
            .
          </Typography>
          <img
            src="/static/img/random/buttons_icons.png"
            width="235"
            className={classes.mobileImageStyle}
          />
        </div>
        <div className={classes.stepContainer}>
          <Typography style={{ fontSize: 14 }}>
            Tapping on different areas of a listing card allows you to perform
            different actions.
          </Typography>
          <img
            src="/static/img/random/card_icon.png"
            width="206"
            className={classes.mobileImageStyle}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(KeyboardControls),
);
